import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  constructor(private http: HttpClient) {}

  createCategory(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/category`, data);
  }

  getCategory(): Observable<any> {
    return this.http.get(`${environment.authUrl}/category`);
  }

  updateCategory(id: string, data: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/category/${id}`, data);
  }

  deleteCategory(id: number): Observable<any> {
    return this.http.delete(`${environment.authUrl}/category/${id}`);
  }

  getCategoryById(id: number): Observable<any> {
    return this.http.get(`${environment.authUrl}/category/${id}`);
  }

  getCategoryByLang(langId: any): Observable<any> {
    return this.http.get(`${environment.authUrl}/category/categoryDropdown/${langId}`);
  }
}
